import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

const GlassPaper = styled(Paper)(({ theme }) => {
    const baseColor =
        theme.palette.mode === 'dark' ? 'rgba(15, 23, 42, 0.55)' : 'rgba(255, 255, 255, 0.65)';
    const gradient =
        theme.palette.mode === 'dark'
            ? 'linear-gradient(135deg, rgba(110, 231, 183, 0.35), rgba(14, 165, 233, 0.25))'
            : 'linear-gradient(135deg, rgba(59, 130, 246, 0.35), rgba(236, 72, 153, 0.25))';
    const shadow =
        theme.palette.mode === 'dark'
            ? '0 30px 60px rgba(2, 6, 23, 0.55)'
            : '0 30px 60px rgba(15, 23, 42, 0.18)';

    return {
        borderRadius: 18,
        position: 'relative',
        border: '1px solid transparent',
        backgroundImage: `linear-gradient(${baseColor}, ${baseColor}), ${gradient}`,
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box',
        backdropFilter: 'blur(22px)',
        WebkitBackdropFilter: 'blur(22px)',
        boxShadow: shadow,
        transition: 'background-color 200ms ease, box-shadow 200ms ease, border-color 200ms ease',
    };
});

export default GlassPaper;
